import React from "react";
import { CareerData } from "../career.data";
import { Text } from "../../components/Text";
import { CvAvatar } from "../career-icon";
import { useTranslation } from "react-i18next";
import clsx from "clsx";

interface TimelineEntryProps {
  entry: CareerData;
  row: string | number;
  gridColumnStart: number;
  gridColumnEnd: number;
  onClick: () => void;
  isActive: boolean;
}

export const TimelineEntry = (props: TimelineEntryProps) => {
  const { t } = useTranslation("cv");
  return (
      <button
        onClick={props.onClick}
        className={clsx("h-full my-2 w-full justify-start gap-2 border-none cursor-pointer snap-start",
          'overflow-x-hidden flex items-center z-10',
          'focus-visible:outline-none',
          'focus-visible:ring focus-visible:ring-foreground focus-visible:ring-offset-4 focus-visible:ring-offset-page ring-contrast focus-visible:z-20', {
            'bg-steel-300 text-page-contrast': !props.isActive,
            'bg-primary text-primary-contrast': props.isActive
          })}
          style={{
            gridRow: props.row,
            gridColumn: `${props.gridColumnStart} / ${props.gridColumnEnd}`,
          }}
      >
        <CvAvatar color="inherit" type={props.entry.type} width="40"/>
        <Text color="inherit" className="truncate" variant="caption">
          {`${t(props.entry.position)} @ ${t(props.entry.company)}`}
        </Text>
      </button>
  );
};
